export const outdatedGenderTuningResourceTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('in _add_gender_preference') !== -1 && desyncdata.indexOf('IndexError: tuple index out of range') !== -1) {
			return {
				type: 'tunableResourceTest3',
				color: 'IndianRed',
				title: 'Outdated Gender Tuning Error',
				text: 'Outdated Gender Tuning Resource requires removing.',
				description: 'Tunable Game Gender Tuning Resource contains incorrect/outdated information.<br/><br/>' +
				'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that contains this resource and remove it. Try starting with the oldest modifications you have.<br/>' +
				'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<?xml version="1.0" ?>
<root>
  <report>
    <version>2</version>
    <sessionid>8005facb81685e396425bf97</sessionid>
    <type>desync</type>
    <sku>ea.maxis.sims4_64.15.pc</sku>
    <createtime>2099-03-31 01:00:02</createtime>
    <buildsignature>Local.Unknown.Unknown.1.99.397.1020-1.300.000.154.Release</buildsignature>
    <categoryid>sim_template.py:1027</categoryid>
    <desyncid>8005facb81685e396425bf97</desyncid>
    <systemconfig/>
    <screenshot/>
    <desyncdata>Exception while updating the sim filter service.. (IndexError: tuple index out of range)
Traceback (most recent call last):
  File "T:\InGame\Gameplay\Scripts\Core\sims4\utils.py", line 179, in wrapper
  File "T:\InGame\Gameplay\Scripts\Server\areaserver.py", line 209, in c_api_server_tick
  File "T:\InGame\Gameplay\Scripts\Server\sims\masked\v174d\injector.py", line 26, in _wrapped_function
  File "T:\InGame\Gameplay\Scripts\Server\sims\masked\v174d\zone_tick.py", line 74, in _turbolib_zone_game_update
  File "T:\InGame\Gameplay\Scripts\Server\zone.py", line 509, in update
  File "T:\InGame\Gameplay\Scripts\Server\filters\sim_filter_service.py", line 791, in update
  File "T:\InGame\Gameplay\Scripts\Server\filters\sim_filter_service.py", line 558, in run
  File "T:\InGame\Gameplay\Scripts\Server\filters\sim_filter_service.py", line 499, in _create_sim_info
  File "T:\InGame\Gameplay\Scripts\Server\filters\tunable.py", line 4322, in create_sim_info
  File "T:\InGame\Gameplay\Scripts\Server\filters\household_template.py", line 385, in create_household
  File "T:\InGame\Gameplay\Scripts\Server\filters\sim_template.py", line 740, in add_template_data_to_sim
  File "T:\InGame\Gameplay\Scripts\Server\filters\sim_template.py", line 1027, in _add_gender_preference
IndexError: tuple index out of rangertim=0
</desyncdata>
  </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/outdatedTunableResourceTest.js